import { Check } from 'lucide-react';

export type ConfidenceValue = 'sure' | 'unsure';

interface ConfidenceButtonsProps {
  value: ConfidenceValue | null;
  onChange: (value: ConfidenceValue) => void;
  disabled?: boolean;
}

const OPTIONS: Array<{ value: ConfidenceValue; label: string }> = [
  { value: 'sure', label: 'Sure' },
  { value: 'unsure', label: 'Not sure' },
];

// WIP-012 (design §5.1) — the Sure/Not sure control. Same size and shape as
// the option buttons in ChoiceResponse (44 px minimum tap height — this is a
// phone in a lecture hall). Purely presentational: it never calls submit
// itself and it never disables anything — ResponseControl decides when a
// selection here reaches the server, and the primary answer's own
// Submit/tap is never gated on it.
export default function ConfidenceButtons({ value, onChange, disabled }: ConfidenceButtonsProps) {
  return (
    <div className="flex gap-1.5" role="group" aria-label="How sure are you?">
      {OPTIONS.map((opt) => {
        const isSelected = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            disabled={disabled}
            aria-pressed={isSelected}
            onClick={() => onChange(opt.value)}
            className={`inline-flex min-h-[44px] items-center gap-1.5 rounded-lg border px-3 py-2 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
              isSelected
                ? 'border-ws-accent bg-ws-accent-quiet text-ws-accent-ink'
                : 'border-ws-border bg-ws-surface text-ws-ink-2 hover:bg-ws-surface-2'
            }`}
          >
            {isSelected && <Check size={13} />}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
